import React from 'react';
import RegionEditorMap from "../components/RegionEditor/RegionEditorMap";
import {Col, Row} from "reactstrap";

class RegionEditor extends React.Component {

    render() {
        return(
            <>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <RegionEditorMap/>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default RegionEditor;